import axios from 'axios';
import { apiUrl } from './apiUrl';

export const get = receipt =>
    axios.get(`${apiUrl}/clientReceipt`, { params: { 'receipt': receipt } })


// WEBPACK FOOTER //
// ./src/baseparking-api/Receipt.js